module.exports = __webpack_public_path__ + "static/img/6.73bc332.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/6.png
// module id = zzeG
// module chunks = 0